<template>
  <section class="l-content">
    <el-card name="hTable">
      <el-form :inline="true" :model="condition">
        <el-form-item label="年检日期">
          <l-datepicker type="daterange" :default="[condition.startDate, condition.endDate]" @change="dataRangeChange"></l-datepicker>
        </el-form-item>
        <el-form-item>
          <el-input v-model="condition.keyword" placeholder="车牌号/责任人/送检人"> </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPageData()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-divider> </el-divider>
    <el-card v-if="pageData">
      <l-table :option="tableOption" :data="pageData.list" :start-index="pageData.startIndex"> </l-table>
      <l-pager :page="pageData" @change="getPageData"></l-pager>
    </el-card>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import yearlyInspectAddoredit from './yearlyInspect_addoredit'
export default {
  computed: {
    ...mapState(['userInfo'])
  },
  name: 'CarYearlyInspect',
  data() {
    return {
      tableOption: {
        stripe: true,
        columns: [
          { label: '序号', type: 'index' },
          { label: '车牌号', prop: 'carNo' },
          { label: '责任人', prop: 'reponsibleUserName' },
          { label: '年检时间', prop: 'yearlyInspectDate', filter: (a, data) => this.$lgh.limitTo(a, 10) },
          { label: '年检到期', prop: 'nextYearlyInspectDate', filter: (a, data) => this.$lgh.limitTo(a, 10) },
          { label: '送检人', prop: 'inspectMan' },
          { label: '总费用(元)', prop: 'totalCost' },
          { label: '年检地', prop: 'yearlyInspectPlace' }
        ],
        operation: {
          width: '220',
          header: { type: 'warning', icon: 'el-icon-plus', label: '新增', click: this.add },
          buttons: [{ type: 'primary', icon: 'el-icon-edit', label: '修改', click: this.edit }]
        }
      },
      condition: {
        keyword: '',
        // enterpriseCode: this.userInfo.enterpriseCode,
        dealState: '',
        pageIndex: 1,
        pageSize: 10
      },
      pageData: null
    }
  },
  created() {
    this.getPageData()
  },
  methods: {
    dataRangeChange(d1, d2) {
      this.condition.startDate = d1
      this.condition.endDate = d2
    },
    async getPageData(pageOption) {
      Object.assign(this.condition, pageOption)
      this.pageData = await this.$lgh.get('api/enterprise/car/yearlyInspect/pagelist', ['enterpriseCode', this.condition])
    },
    async add() {
      await this.$lgh.openDialog({
        ins: yearlyInspectAddoredit,
        title: '新增年检记录',
        data: {
          departList: this.departList,
          roleList: this.roleList,
          dataInfo: {
            enterpriseCode: this.userInfo.enterpriseCode
          }
        }
      })
      this.$lgh.toastSuccess('新建年检记录成功')

      this.getPageData()
    },
    async edit(item) {
      await this.$lgh.openDialog({
        ins: yearlyInspectAddoredit,
        title: '修改年检记录',
        data: {
          dataInfo: Object.assign({}, item)
        }
      })
      this.$lgh.toastSuccess('修改年检记录成功')
      this.getPageData()
    }
  }
}
</script>
